// Sample store state for the component previews (see ./mount.js). Shapes mirror what
// the admin-service returns, so the real components render exactly as in production.

export const securityState = {
    Auth: { adminServiceUrl: "/admin" },
    Security: {
        bans: [
            { value: "45.83.12.9", scenario: "credential stuffing on /auth", origin: "crowdsec", duration: "876000h0m0s", type: "ban", addedBy: "System" },
            { value: "203.0.113.7", scenario: "manual operator block", origin: "cscli", duration: "71h58m3s", type: "ban", addedBy: "andrej@kslnetwork.com" },
            { value: "185.220.101.0/24", scenario: "tor exit sweep", origin: "lists", duration: "876000h0m0s", type: "ban", addedBy: "System" },
        ],
        allowlist: [
            { value: "198.51.100.0/24", description: "office VPN egress", expiration: "", addedBy: "andrej@kslnetwork.com" },
            { value: "203.0.113.42", description: "monitoring probe", expiration: "2026-08-15T00:00:00.000Z", addedBy: "e2e-operator@kslnetwork.com" },
        ],
        error: null,
    },
};
